export default {
  labels: {
    powered_by: 'powered by',
  },
};
